import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { IconChevronLeft, IconChevronRight } from '../Icon/index';
import { IconButton } from '../IconButton/IconButton';
import { StyledCarouselNavControls } from './CarouselNavControls.styles';

/**
 * Buttons used to move forward and backward through a carousel of
 * slides. Used by `Carousel`.
 *
 * @since 8.71.0
 */
export var CarouselNavControls = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var leftButtonProps = _ref.leftButtonProps,
    rightButtonProps = _ref.rightButtonProps;
  return /*#__PURE__*/React.createElement(StyledCarouselNavControls, {
    ref: forwardedRef
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    "aria-hidden": true,
    appearance: "circle",
    "aria-label": "Previous",
    icon: /*#__PURE__*/React.createElement(IconChevronLeft, null),
    size: "sm",
    tabIndex: "-1",
    title: "Previous items"
  }, leftButtonProps)), /*#__PURE__*/React.createElement(IconButton, _extends({
    "aria-hidden": true,
    appearance: "circle",
    "aria-label": "Next",
    icon: /*#__PURE__*/React.createElement(IconChevronRight, null),
    size: "sm",
    tabIndex: "-1",
    title: "Next items"
  }, rightButtonProps)));
});
CarouselNavControls.displayName = 'CarouselNavControls';
CarouselNavControls.propTypes = {
  /**
   * Props passed by `Carousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  leftButtonProps: PropTypes.object,
  /**
   * Props passed by `Carousel`. Contains `onClick` and `disabled`.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  rightButtonProps: PropTypes.object
};